import { defaultPaginationHeaders } from "apiHelper/defaultHeaders";
import { IHeadersDataPagination } from "interfaces/pagination";
import { axiosConfig, makeAxiosRequest } from "utils/functions";

export const callApi = async (method:string,url:string,body:any,pagination:IHeadersDataPagination=defaultPaginationHeaders,extraHeaders?: any,isFormData:boolean = false) => {
    const dataConfig = axiosConfig(method, url, {...pagination,...extraHeaders}, body,isFormData);
    return await makeAxiosRequest(dataConfig);
}